import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Grid, Typography, Link } from '@material-ui/core';


const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
  },
  description: {
    paddingTop: '2vh',
    fontSize: '16px',
    color: '#4e4e4e',
    textAlign: 'center',
    marginRight: '7vw',
    marginLeft: '7vw'
  },
  title: {
    fontWeight: 700,
    textAlign: 'center',
    fontSize: 32,
    marginTop: '8vh',
    lineHeight: 'normal'
  },
  repository: {
    textAlign: 'center',
    fontSize: 20,
    marginTop: '8vh',
    color: '#b15858'
  },
  url: {
    textAlign: 'center',
    fontSize: 20,
    marginTop: '1vh'
  }
}));

const Header = props => {
  const { className, ...rest } = props;
  const classes = useStyles();
  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Grid
        container
        justify="center"
        style={{ marginTop: '-1%' }}
      >
        <Grid item>
          <Typography className={classes.title}>swagger-autogen</Typography>
          <Typography className={classes.description} >NPM module developed to performs the automatic construction of the Swagger documentation. The module is able to identify the endpoints and automatically capture methods such as get, post, put, and so on, along with the path. In addition to the methods and the path, the module can also identify the parameters in the path, query, body and response status code. It is possible to add information such as: endpoint description, parameter description, defininitions, security, among others. It is also possible to ignore or disable the automatic capture of an endpoint (having to manually inform each information in this case). The module generates a .json file with the documentation in the swagger format.</Typography>
          <Typography className={classes.repository}>npmjs</Typography>
          <Typography className={classes.url}>
            <Link
              component="a"
              href="https://www.npmjs.com/package/swagger-autogen"
              target="_blank"
            >
              https://www.npmjs.com/package/swagger-autogen
              </Link>
          </Typography>
          <Typography className={classes.repository}>Repository</Typography>
          <Typography className={classes.url}>
            <Link
              component="a"
              href="https://github.com/davibaltar/swagger-autogen"
              target="_blank"
            >
              https://github.com/davibaltar/swagger-autogen
              </Link>
          </Typography>
          <Typography className={classes.repository}>Complete example</Typography>
          <Typography className={classes.url}>
            <Link
              component="a"
              href="https://github.com/davibaltar/example-swagger-autogen"
              target="_blank"
            >
              https://github.com/davibaltar/example-swagger-autogen
              </Link>
          </Typography>
        </Grid>
      </Grid>
      <hr style={{ borderColor: '#E8E8E8', borderTop: 'none', borderLeft: 'none', borderRight: 'none', paddingTop: '3vh' }} />
    </div>
  );
};


export default Header;